import { ObjectID } from 'bson';
import { parseDomain, fromUrl } from "parse-domain";
import { load } from '@fingerprintjs/botd'
import isMobile from 'ismobilejs';
//import { Logger } from './logger';

export async function validateWithBotd()
{
  let validation = null;
  await load()
    .then((botd) => botd.detect())
    .then((result) => validation = result['bot'])
    .catch((error) => console.error(error))
  return validation;
}

export function detectDevice()
{
  const userAgent = navigator.userAgent;
  let isMobileDevice = isMobile(userAgent).any;
  let isTabletDevice = isMobile(userAgent).tablet;
  if(isTabletDevice == true)
  {
    return "tablet";
  }
  if(isMobileDevice == true)
  {
    return "mobile";
  }
  return "desktop";
}


export function getUtcTimestampNumeric()
{
  let now = new Date();
  let utc_timestamp = Date.UTC(now.getFullYear(),now.getMonth(), now.getDate() , 
      now.getHours(), now.getMinutes(), now.getSeconds(), now.getMilliseconds());
  return utc_timestamp;
}

export function getUtcTimestamp()
{
  let timestamp = new Date().toISOString();
  return timestamp;
}

export function getTimestampRange(lastTimestamp, firstTimestamp)
{
    let lastDate = Date.parse(lastTimestamp);
    let firstDate = Date.parse(firstTimestamp);

    let difference = (lastDate - firstDate) / 1000;
    return difference;
}

export function generateGuid() {
  let key = Math.floor(Date.now() / 1000);
  let id  = new ObjectID(key);
  return id.toString();
}

export function getHref()
{
  let href = "none";
  try
  {
    href = window.location.href;
  }
  catch(ex)
  {
    console.log(ex);//Logger.logError(ex, "getHref", "", "");
  }
  return href;
}

export function getUtmData()
{
  try
  {
    let data = {};
    let search = "";
    try
    {
      search = location.search.substring(1);
      data = JSON.parse('{"' + search.replace(/&/g, '","').replace(/=/g,'":"') + '"}', function(key, value) { return key===""?value:decodeURIComponent(value) });
    }
    catch(ex)
    {
      data = {};
    }
    
    let source = null;
    let medium = null;
    let campaign = null;

    if(data['utm_source'] != null)
    {
      source = data['utm_source'];
    }
    else
    {
      source = "none";
    }
    if(data['utm_campaign'] != null)
    {
      campaign = data['utm_campaign'];
    }
    else
    {
      campaign = "none";
    }
    if(data['utm_medium'] != null)
    {
      medium = data['utm_medium'];
    }
    else
    {
      medium = "none";
    }

    return [source, medium, campaign];
  }
  catch(ex)
  {
    console.log(ex);
  }
  return ["none","none","none"]
}

export function getDomain()
{
  try
  {
    let href = window.location.href;
    let aiDomain = null;
    let { subDomains, domain, topLevelDomains } = parseDomain(fromUrl(href));
    let topLevelDomainsOnlyList = ["app", "myshopify","goog", "herokuapp"];
    let isTopLevelDomainsOnlyApply = false;

    for (let i = 0; i < topLevelDomainsOnlyList.length; i++) 
    {
      let value = topLevelDomainsOnlyList[i];
      if(topLevelDomains.includes(value))
      {
        isTopLevelDomainsOnlyApply = true;
      }
    }
    if(isTopLevelDomainsOnlyApply == true)
    {
      aiDomain = topLevelDomains.join('.');
    }
    else
    {
      aiDomain = domain + "." + topLevelDomains.join('.');
    }
    if(aiDomain.includes("."))
    {
      aiDomain = aiDomain.replace(".","_");
    }
    return aiDomain; 
  }
  catch(ex)
  {
    console.log(ex);//Logger.logError(ex, "getDomain", "", "");
  }
  return "localhost";
}
  
export function getScrollPercentage() 
{
    let docHeight = Math.max(
      document.body.scrollHeight || 0, 
      document.documentElement.scrollHeight || 0,
      document.body.offsetHeight || 0, 
      document.documentElement.offsetHeight || 0,
      document.body.clientHeight || 0, 
      document.documentElement.clientHeight || 0
    );

    let windowYScroll = window.pageYOffset || 
      document.body.scrollTop ||
      document.documentElement.scrollTop || 0;

    let windowHeight = window.innerHeight || 
    document.documentElement.clientHeight ||
    document.body.clientHeight || 0;

    let scrollPosition = parseFloat(((windowYScroll + windowHeight) / docHeight) * 100).toFixed(2);
    return scrollPosition;
}

export function convertStringToNumber(value)
{
  let converted = 0;
  try
  {
    converted = Number(value);
  }
  catch(ex)
  {
    console.log(ex);
    //Logger.logError(ex, "convertStringToNumber", "", "");
  }
  return converted;
}

